import { blue, grey } from '../../../common/styles/colours';
export var TextButtonStylePropertiesByVariant = {
    default: function (theme) {
        var _a, _b, _c, _d;
        return ({
            backgroundColor: 'transparent',
            hoverBackgroundColor: 'transparent',
            contentColor: (_a = theme.contentAccent) !== null && _a !== void 0 ? _a : blue[600],
            hoverContentColor: (_b = theme.hoverAccent) !== null && _b !== void 0 ? _b : blue[700],
            activeContentColor: (_c = theme.clickedAccent) !== null && _c !== void 0 ? _c : blue[800],
            disabledContentColor: (_d = theme.disabledSecondary) !== null && _d !== void 0 ? _d : grey[400],
            textDecoration: 'underline',
        });
    },
    subtle: function (theme) {
        var _a, _b, _c, _d;
        return ({
            backgroundColor: 'transparent',
            hoverBackgroundColor: 'transparent',
            contentColor: (_a = theme.contentPrimary) !== null && _a !== void 0 ? _a : grey[900],
            hoverContentColor: (_b = theme.contentPrimary) !== null && _b !== void 0 ? _b : grey[900],
            activeContentColor: (_c = theme.contentSecondary) !== null && _c !== void 0 ? _c : grey[800],
            disabledContentColor: (_d = theme.disabledSecondary) !== null && _d !== void 0 ? _d : grey[400],
            textDecoration: 'underline',
        });
    },
};
//# sourceMappingURL=TextButtonStylePropertiesByVariant.js.map